import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class ActivityRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }
  convertirADosDigitos(numero) {
    // Convertir el número a una cadena para verificar su longitud
    let numeroString = numero.toString();

    // Verificar si el número es flotante y tiene más de dos dígitos
    if (numeroString.includes('.') && numeroString.split('.')[1].length > 2) {
        // Redondear el número a dos decimales
        return parseFloat(numero).toFixed(2);
    } else {
        // Si el número es entero o tiene dos o menos dígitos decimales, devolverlo tal como está
        return numero;
    }
  }
  async getActivityByIdTrip(idTrip) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/trip/${idTrip}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data.activities;
    } catch (e) {
      return [];
    }
  }

  async getActivities(page, rowsPerPage) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/activity?pageNum=${page}&pageSize=${rowsPerPage}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response;
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
}

Container.set({ id: ActivityRepository, type: ActivityRepository });

export default ActivityRepository;
